import { ServiceRechargeInvoicesListResponse } from '@/modules/sales/serviceRechargeInvoices/services/apiValidations/serviceRechargeInvoicesApiValidation.ts'

export const serviceRechargeInvoicesPage1: ServiceRechargeInvoicesListResponse =
  {
    pagination: {
      count: 2,
      start: 0,
      limit: 20,
      end: 2,
      next: false,
      prev: false,
      pages: 1,
      range: [1],
      total: 2
    },
    items: [
      {
        quoteId: 184502,
        creditId: 90231,
        clientId: 45120,
        paymentDate: '2026-06-10T14:32:05Z',
        rechargeValue: 5.0,
        partnerVat: 'V-10230811',
        partnerName: 'Juan Pérez',
        partnerEmail: 'juan.perez@example.com',
        partnerPhone: '04141234567',
        feeAmountBs: 502.16,
        feeAmountUsd: 2,
        exchangeRate: 1.5,
        ivaBs: 0,
        odooAmountBs: 0
      },
      {
        quoteId: 184503,
        creditId: 90232,
        clientId: 45121,
        paymentDate: '2026-06-11T09:15:30Z',
        rechargeValue: 10.0,
        partnerVat: 'V-20345678',
        partnerName: 'María González',
        partnerEmail: 'maria.gonzalez@example.com',
        partnerPhone: '04247654321',
        feeAmountBs: 1004.32,
        feeAmountUsd: 4,
        exchangeRate: 1.6,
        ivaBs: 0,
        odooAmountBs: 0
      }
    ]
  }
